<template>
	<div>
		<footer class="p-5 bg-bluegrey mt-3 pb-5">
			<div class="container">
				<div class="row">
					<div class="col-md-4">
						<ul class="list-inline">
							<li class="list-inline-item m-1">
								<a class="p-2 bg-secondtheme hover">
									<span class="mdi mdi-facebook font-white"></span>
								</a>
							</li>
							<li class="list-inline-item m-1">
								<a class="p-2 bg-secondtheme hover">
									<span class="mdi mdi-youtube font-white"></span>
								</a>
							</li>
							<li class="list-inline-item m-1">
								<a class="p-2 bg-secondtheme hover">
									<span class="mdi mdi-twitter font-white"></span>
								</a>
							</li>
						</ul>
						<hr />
						<div>
							<h2 class="text-uppercase font-secondtheme font-kanit">Subscribe</h2>
							<div class="input-group mb-3">
								<input
									type="text"
									class="form-control rounded-0"
									placeholder="Email"
									aria-describedby="basic-addon2"
								/>
								<div class="input-group-append ml-2">
									<button
										class="input-group-text bg-secondtheme font-white rounded-0"
										id="basic-addon2"
									>Subscribe</button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-8 p-0">
						<div class="row p-0">
							<div class="col-md-4">
								<h3 class="text-uppercase font-secondtheme font-kanit">LINK</h3>
								<ul class="list-unstyled font-white ml-3">
									<li>
										<router-link
											class="font-white"
											to="home"
										>1. Home</router-link>
									</li>
									<li>
										<router-link
											class="font-white"
											to="service"
										>2. Service</router-link>
									</li>
									<li>
										<router-link
											class="font-white"
											to="product"
										>3. Product</router-link>
									</li>
									<li>
										<router-link
											class="font-white"
											to="project"
										>4. Project</router-link>
									</li>
									<li>
										<router-link
											class="font-white"
											to="contact"
										>5. Contact</router-link>
									</li>
								</ul>
							</div>
							<div class="col-md-8">
								<h3 class="text-uppercase font-secondtheme font-kanit">
									Contact
									<br />
									<span class="font-secondtheme font-1x">EMERALD TECH ADVANCE CO., LTD.</span>
									<br />
									<span class="font-secondtheme font-1x">บริษัท เอ็มเมอรัลด์ เทค แอดวานซ์ จำกัด</span>
								</h3>
								<ul class="list-unstyled font-white ml-3">
									<li>
										<a>
											<span class="mdi mdi-home"></span> ที่อยู่ : ชั้น 4 เลขที่ 43 ซอยประเสริฐมนูกิจ 5 ถนนประเสริฐมนูกิจ แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพมหานคร 10230
										</a>
									</li>
									<li>
										<a>
											<span class="mdi mdi-home"></span> ติดต่อได้ : ชั้น 4 เลขที่ 43 ซอยประเสริฐมนูกิจ 5 ถนนประเสริฐมนูกิจ แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพมหานคร 10230
										</a>
									</li>
									<li>
										<a>
											<span class="mdi mdi-phone"></span> 02 570-5580 ต่อ 4111
										</a>,
										<a>
											<span class="mdi mdi-phone"></span> 094 325 5424
										</a>
									</li>
									<li>
										<a>
											<span class="mdi mdi-email-newsletter"></span> info@emeraldtech.co.th
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>

		<div
			v-show="loading"
			class="loader-container"
		>
			<div class="loader">
				<div class="loader--dot"></div>
				<div class="loader--dot"></div>
				<div class="loader--dot"></div>
				<div class="loader--dot"></div>
				<div class="loader--dot"></div>
				<div class="loader--dot"></div>
				<div class="loader--text"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data: () => ({
			loading: true,
		}),
		mounted() {
			setTimeout(() => {
				this.loading = false;
			}, 2000);
		},
	};
</script>
